import { render } from "./ViewAbonnementPage.vue?vue&type=template&id=529e33da&ts=true"
import script from "./ViewAbonnementPage.vue?vue&type=script&lang=ts"
export * from "./ViewAbonnementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__